"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = _interopRequireDefault(require("../components/svg"));

var _button = _interopRequireDefault(require("../components/button"));

var _link = _interopRequireDefault(require("../components/link"));

var _sections = require("../components/contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var variants = ['primary', 'ghost', 'ghost-blue', 'body', 'nav', 'legal', 'white'];
/**
 * Maps to the ButtonLink content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/buttonLink/fields
 */

var ButtonLinkWidget = function ButtonLinkWidget(_ref) {
  var _model$fields, _model$fields$icon, _model$fields$icon$fi, _model$fields2, _model$fields3, _model$fields4, _model$fields5, _model$fields6, _model$fields7;

  var model = _ref.model;
  // Get fields that need to be converted for component
  var icon = model === null || model === void 0 ? void 0 : (_model$fields = model.fields) === null || _model$fields === void 0 ? void 0 : (_model$fields$icon = _model$fields.icon) === null || _model$fields$icon === void 0 ? void 0 : (_model$fields$icon$fi = _model$fields$icon.fields) === null || _model$fields$icon$fi === void 0 ? void 0 : _model$fields$icon$fi.id;
  icon = icon && /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: icon,
    className: "buttonIcon"
  }); // Make sure legacy buttonLinks have an appropriate variant

  var variant = model === null || model === void 0 ? void 0 : (_model$fields2 = model.fields) === null || _model$fields2 === void 0 ? void 0 : _model$fields2.type;
  var componentProps = {
    className: model === null || model === void 0 ? void 0 : (_model$fields3 = model.fields) === null || _model$fields3 === void 0 ? void 0 : _model$fields3.className,
    href: model === null || model === void 0 ? void 0 : (_model$fields4 = model.fields) === null || _model$fields4 === void 0 ? void 0 : _model$fields4.url,
    icon: icon,
    rel: model === null || model === void 0 ? void 0 : (_model$fields5 = model.fields) === null || _model$fields5 === void 0 ? void 0 : _model$fields5.rel,
    target: model === null || model === void 0 ? void 0 : (_model$fields6 = model.fields) === null || _model$fields6 === void 0 ? void 0 : _model$fields6.target,
    // Coming from contentful, let's default variant to nav items.
    variant: variants.includes(variant) ? variant : 'nav'
  };
  var children = model === null || model === void 0 ? void 0 : (_model$fields7 = model.fields) === null || _model$fields7 === void 0 ? void 0 : _model$fields7.text; // Use type field to determine Button or Link

  var component = null;

  switch (componentProps.variant) {
    case 'body':
    case 'nav':
    case 'legal':
    case 'white':
      component = /*#__PURE__*/_react["default"].createElement(_link["default"], componentProps, children);
      break;

    default:
      component = /*#__PURE__*/_react["default"].createElement(_button["default"], componentProps, children);
  }

  return component;
};

ButtonLinkWidget.propTypes = {
  model: _propTypes["default"].shape({
    fields: _propTypes["default"].shape({
      className: _propTypes["default"].string,
      icon: _propTypes["default"].node,
      rel: _propTypes["default"].string,
      target: _propTypes["default"].oneOf(['_self', '_blank', '_parent', '_top']),
      text: _propTypes["default"].string.isRequired,
      type: _propTypes["default"].oneOf(variants)
    })
  })
};
ButtonLinkWidget.defaultProps = {
  model: {}
};
(0, _sections.registerWidget)('buttonLink', ButtonLinkWidget);
var _default = ButtonLinkWidget;
exports["default"] = _default;